import { UploadVideoOptions } from '@sparemin/api-sdk';
import { State } from 'redux/types';
import { MultipartAbortOptions, VideoUploadStateValue } from './types';

const videoUploadStateSelector = (state: State): VideoUploadStateValue =>
  state.get('videoUpload');

export const videoUploadProgressSelector = (state: State) =>
  videoUploadStateSelector(state)?.uploadProgress;

export const isVideoUploadingSelector = (state: State) =>
  videoUploadStateSelector(state)?.isUploading;

export const videoUploadOptionsSelector = (state: State): UploadVideoOptions =>
  videoUploadStateSelector(state)?.videoUploadOptions;

export const multipartAbortOptionsSelector = (
  state: State,
): MultipartAbortOptions | undefined =>
  videoUploadStateSelector(state)?.multipartAbortOptions;

export const uploadIdentifierSelector = (state: State): string | undefined =>
  videoUploadStateSelector(state)?.uploadIdentifier;

export const uploadedVideoIdSelector = (state: State): number | undefined =>
  videoUploadStateSelector(state)?.uploadedVideoId;

/**
 * True while a local-File upload for `identifier` is in flight. A caller
 * dispatching `uploadVideoToStorage` for the same file uses this to join the
 * running upload instead of starting a duplicate one.
 */
export const isCurrentlyUploadingVideoSelector = (identifier: string) => (
  state: State,
): boolean =>
  isVideoUploadingSelector(state) === true &&
  uploadIdentifierSelector(state) === identifier;
